<span>{{ emoji() }}</span>
